const state = {
  meetings: [],
  list: [],
  pagination: { page: 1, perPage: 20, total: 0 },
  options: {},
  formSend: false,
  reloadList: false,
  currentMeeting: null,
  currentGuests: [],
  guestsByMeeting: {},
};

export default state;
